import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

type TableRowProps = ComponentPropsWithoutRef<'tr'> & {
	isSelected?: boolean;
};

const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
	({ isSelected = false, className, ...props }, ref) => {
		const { onClick } = props;

		return (
			<tr
				{...props}
				ref={ref}
				data-is-selected={isSelected}
				data-is-clickable={!!onClick}
				className={twMerge(
					'relative h-[3.75rem] scale-100 bg-dm-black text-sm transition-all data-[is-selected=false]:hover:bg-dm-gray md:text-base',
					'data-[is-selected=true]:bg-dm-dark-gold',
					'[&_td]:border-b [&_td]:border-dm-black3',
					'[&_th]:border-b [&_th]:border-dm-black3',
					'data-[is-clickable=true]:cursor-pointer',
					className
				)}
			/>
		);
	}
);

TableRow.displayName = 'TableRow';

export default TableRow;
